<template>
  <div id="defaultId1">
    <div class="pb20">
      <div v-if="isFinacialshow">
        <gui_card
          id="ge6845"
          :class="powerArr[0]?.hasPrivilege ? ' ' : 'vaguesuo'"
          class="uc1096"
          label=""
          :isShowLabel="false"
        >
          <div :class="powerArr[0]?.hasPrivilege ? ' ' : 'vague'">
            <h2 class="operations-head-content flex_center_between_box">
              <div class="operations-head detail_title_20">
                <div class="operations-head">
                  <span class="operations-head">{{
                    $t("ContentTabs.FinancialHighlights")
                  }}</span>
                  <div class="Financial-icon-part Financial-icon-parttwo">
                    <!-- <svg t="1749001947538" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="6416" width="20" height="20"> 
                      <path
                        d="M528 1024C793.6 1024 1024 793.6 1024 528 1024 230.4 793.6 0 528 0 230.4 0 0 230.4 0 528 0 793.6 230.4 1024 528 1024zM512 64c246.4 0 448 201.6 448 448s-201.6 448-448 448S64 758.4 64 512 265.6 64 512 64z"
                        fill="#FF7600" p-id="6417"></path>
                      <path d="M512 256m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#FF7600" p-id="6418"></path>
                      <path d="M640 768h-64V384h-160v32h64v352h-64v32h224z" fill="#FF7600" p-id="6419"></path>
                    </svg> -->
                    <i class="iconfont icon-gantanhao1 huanggantanhaoicon"></i>
                    <div class="Financial-icon-box Financial-icon-boxtwo">
                      {{ $t("FinancialHighlight.Financialperformancedata") }}
                    </div>
                  </div>
                </div>
                <i
                  class="iconfont icon-rili riliicon"
                  @click="createDialog = true"
                ></i>
                <!-- <svg @click="createDialog = true" t="1718848057496" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  style="margin-left: 20px;cursor: pointer" xmlns="http://www.w3.org/2000/svg" p-id="4445"
                  height="2.28rem">
                  <path
                    d="M935.812877 88.243078h-87.685776V29.784188a29.226886 29.226886 0 1 0-58.453771 0v58.45889H234.331789V29.784188a29.226886 29.226886 0 1 0-58.453771 0v58.45889H88.187123C39.762336 88.243078 0.501347 127.498948 0.501347 175.923735v759.945098c0 48.429907 39.260989 87.685776 87.685776 87.685776h847.625754c48.424787 0 87.685776-39.260989 87.685776-87.685776V175.928854c0-48.424787-39.260989-87.685776-87.685776-87.685776z m29.226886 847.625755a29.232005 29.232005 0 0 1-29.226886 29.232005H88.187123a29.232005 29.232005 0 0 1-29.226886-29.232005V351.300406h906.079526v584.568427z m0-643.027317H58.960237V175.928854a29.226886 29.226886 0 0 1 29.226886-29.226885h87.685776v29.226885a29.226886 29.226886 0 1 0 58.453771 0v-29.226885h555.341541v29.226885a29.226886 29.226886 0 1 0 58.453771 0v-29.226885h87.685776a29.226886 29.226886 0 0 1 29.226885 29.226885V292.841516z"
                    p-id="4446" fill="#1290C9"></path>
                  <path
                    d="M512 526.671958c24.179117 0 43.842888-19.663771 43.842888-43.842888A43.842888 43.842888 0 0 0 512 438.986182a43.807052 43.807052 0 0 0-43.842888 43.842888c0 24.173998 19.597218 43.842888 43.842888 43.842888zM745.825323 877.409942c24.184237 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888c0.005119 24.179117 19.602337 43.842888 43.842888 43.842888zM512 702.03839c24.179117 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768A43.842888 43.842888 0 0 0 512 702.03839zM745.825323 526.671958c24.184237 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.807052 43.807052 0 0 0-43.842888 43.842888c0.005119 24.173998 19.602337 43.842888 43.842888 43.842888zM745.825323 702.03839c24.184237 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768c0.005119 24.184237 19.602337 43.842888 43.842888 43.842888zM512 877.409942c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 877.409942c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 702.03839c24.179117 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 526.671958c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.807052 43.807052 0 0 0-43.842888 43.842888c0 24.173998 19.597218 43.842888 43.842888 43.842888z"
                    p-id="4447" fill="#1290C9"></path>
                </svg> -->
              </div>
              <div
                v-if="parentTablelist.length > 0"
                class="ViewMore contclass flex_center"
                @click="scrollToTop('#Card')"
              >
                <span>{{ $t("FinancialHighlight.FinancialHighlights") }}</span>
                <div class="Financial-icon-part">
                  <!-- <svg t="1749001947538" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="6416" width="20" height="20">
                    <path
                      d="M528 1024C793.6 1024 1024 793.6 1024 528 1024 230.4 793.6 0 528 0 230.4 0 0 230.4 0 528 0 793.6 230.4 1024 528 1024zM512 64c246.4 0 448 201.6 448 448s-201.6 448-448 448S64 758.4 64 512 265.6 64 512 64z"
                      fill="#FF7600" p-id="6417"></path>
                    <path d="M512 256m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#FF7600" p-id="6418"></path>
                    <path d="M640 768h-64V384h-160v32h64v352h-64v32h224z" fill="#FF7600" p-id="6419"></path>
                  </svg> -->
                  <i class="iconfont icon-gantanhao1 huanggantanhaoicon"></i>
                  <div class="Financial-icon-box">
                    {{ $t("FinancialHighlight.Whenthesubjectsdata") }} <br />
                    {{ $t("FinancialHighlight.Byprovidingyou") }}
                  </div>
                </div>
              </div>
            </h2>
            <tableVue
              :profitablitylist="profitablitylist"
              :nodataYears="nodataYears1"
              :yearslist="yearslist1"
              :untia="untia"
              :createDialog="createDialog"
              @createDialogcheck="createDialogcheck"
            ></tableVue>
          </div>
        </gui_card>

        <gui_card
          class="uc1096 mt10"
          :class="powerArr[1]?.hasPrivilege ? ' ' : 'vaguesuo'"
          label=""
          :isShowLabel="false"
          v-if="Related && parentTablelist.length > 0"
        >
          <div id="Card" :class="powerArr[1]?.hasPrivilege ? ' ' : 'vague'">
            <h2 class="operations-head-content flex_center_between_box">
              <span class="operations-head">{{
                $t("FinancialHighlight.FinancialHighlightsTitle")
              }}</span>
              <i
                class="iconfont icon-cuowu cuowuicon"
                @click="Related = false"
              ></i>

              <!-- <svg @click="Related = false" t="1718863593010" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4791" width="30" height="30">
                <path
                  d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
                  fill="#333333" p-id="4792"></path>
              </svg> -->
            </h2>

            <!-- 关联公司 -->
            <div class="computer_right_cont_box">
              <div
                class="infinite-list-wrapper"
                v-infinite-scroll="infiniteScroll"
                style="overflow: auto"
                :infinite-scroll-disabled="false"
                :infinite-scroll-distance="5"
              >
                <div class="ecahrts-header ecahrts-header-one">
                  <span class="title-left">
                    <span
                      style="cursor: pointer; margin-right: 5px; width: 450px"
                      class="line_1 relate-left"
                      >{{ $t("FinancialHighlight.CompanyName") }}</span
                    >
                  </span>
                  <span
                    class="relate-Financial"
                    style="font-family: 'Arial Bold'"
                    >{{ $t("FinancialHighlight.CompanyID") }}</span
                  >
                  <span
                    class="relate-Financial"
                    style="font-family: 'Arial Bold'"
                    >{{ $t("FinancialHighlight.Country") }}</span
                  >
                  <span
                    class="relate-Financial"
                    style="font-family: 'Arial Bold'"
                    >{{ $t("FinancialHighlight.CompanyStatus") }}</span
                  >
                  <span
                    class="relate-Financial"
                    style="font-family: 'Arial Bold'"
                    >{{ $t("FinancialHighlight.Relations") }}</span
                  >

                  <div class="head_loging"></div>
                </div>
                <div
                  class="footer"
                  v-for="(item, index) in parentTablelist"
                  :key="index"
                  v-loading="item.loading2"
                >
                  <div class="ecahrts-header">
                    <span class="title-left">
                      <span
                        style="
                          cursor: pointer;
                          margin-right: 5px;
                          width: 450px;
                          font-family: Arial;
                        "
                        class="line_1 relate-left"
                        @click="setid(item)"
                        >{{ item.nameEn }}</span
                      >
                    </span>
                    <span class="relate-Financial">{{ item.id }}</span>
                    <span class="relate-Financial">{{ item.country }}</span>
                    <span class="relate-Financial">{{ item.status }}</span>
                    <span class="line_1 relate-Financial">{{
                      item.typeEn
                    }}</span>
                    <div class="head_loging">
                      <el-switch
                        active-color="#55B419"
                        :value="loginStatus1[index]"
                        @change="loginPop(index, item.aaaid, item.nameEn)"
                      ></el-switch>
                    </div>
                  </div>
                  <div v-if="loginStatus1[index]" class="ecahrtstu">
                    <tableVuetwo
                      class="tableVuetwo"
                      :profitablitylist="item.profitablitylist1"
                      :yearslist="item.yearslist"
                      :nodataYears="item.nodataYears1"
                      :dia="id3a"
                      :untia="untia"
                    >
                    </tableVuetwo>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </gui_card>
      </div>
      <gui_card v-else id="ge6845" class="uc1096" label="" :isShowLabel="false">
        <div>
          <h2 class="operations-head-content flex_center_between_box">
            <span class="operations-head detail_title_20"
              >{{ $t("ContentTabs.FinancialHighlights") }}
            </span>
          </h2>

          <div class="flex_center">
            <img
              class="nodataImg"
              src="../../../../assets/images/noDate.png"
              alt=""
            />
          </div>
        </div>
      </gui_card>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
  <!--srcviewscompanydetailsBackgroundSnapshotvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import {
  getrelatedCompanylist,
  getFinancials,
  getPerformanceSummary,
} from "@/api/companyApi";
import rectcard from "../../../../components/rectCard/index.vue";
import content_text from "../../../../components/text_content/index.vue";
import gui_card from "../../../../components/gui_card/gui_card.vue";
import tableVue from "../Performance/components/table.vue";
import tableVuetwo from "../Performance/components/tabletwo.vue";
import ReLogin from "../../../../components/ReLogin.vue";
import { mixins1 } from "@/mixins/index";
import { getPartPrivilege } from "@/api/companyApi";

//importEnd

export default {
  name: "",

  props: {},
  mixins: [mixins1],
  components: {
    // gui_card start
    gui_card,
    // gui_card end
    tableVuetwo,
    rectcard,
    content_text,
    tableVue,
    ReLogin,
  },
  created() {
    this.getPartPrivilegeList();
    this.getFinancialsList();
  },
  watch: {
    "$i18n.locale": {
      handler(newVal, oldVal) {
        this.getPerformanceSummaryList();
        this.getrelateList();
        this.getFinancialsList();
        this.getlist();
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  mounted() {
    this.getPerformanceSummaryList();
    this.getrelateList();
  },
  data() {
    return {
      reLoginVis: false,
      Related: true,
      isFinacialshow: true,
      untia: "",
      yearslist1: [],
      createDialog: false,
      parentTablelist: [],
      loginStatus1: [],
      id3a: [],
      nodataYears1: [],
      page: {
        pageNo: 1,
        pageSize: 20,
        total: 0,
      },
      profitablitylist: [
        {
          lists: [
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
          ],
          name: "Return on Equity:",
        },

        {
          lists: [
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
          ],
          name: "Profit Margin:",
        },
      ],
      profitablitylist1: [
        {
          lists: [
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
          ],
          name: "Return on Equity:",
        },

        {
          lists: [
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
          ],
          name: "Profit Margin:",
        },
      ],
      companyList: [],
      noMore: false, // 控制滚动禁用
      routeLoad: false, // 控制滚动禁用
      icon: "",
      showBackToTop: false,
      newDialog: false,
      powerArr: [],
      manManagementSummary: [],
      // srcviewscompanydetailsBackgroundSnapshotvueDataEnd
    };
  },
  methods: {
    getPartPrivilegeList() {
      getPartPrivilege({
        moduleId: 437,
      }).then((res) => {
        this.powerArr[0] = res.data.filter((item) => item.id == "454")[0];
        this.powerArr[1] = res.data.filter((item) => item.id == "455")[0];
      });
    },
    getPerformanceSummaryList() {
      getPerformanceSummary({ id3a: this.$route.query.id3a })
        .then((res) => {
          if (res.code == 200) {
            this.manManagementSummary = [
              {
                name: this.$t("FinancialHighlight.Revenue"),
                id: this.$t("FinancialHighlight.Revenue"),
                num: res.data.revenue,
              },
              {
                name: this.$t("FinancialHighlight.Profit"),
                id: this.$t("FinancialHighlight.Profit"),
                num: res.data.profit,
              },
              {
                name: this.$t("FinancialHighlight.Growth"),
                id: this.$t("FinancialHighlight.Growth"),
                num: res.data.growth,
              },
              {
                name: this.$t("FinancialHighlight.Liquidity"),
                id: this.$t("FinancialHighlight.Liquidity"),
                num: res.data.liquidity,
              },
              {
                name: this.$t("FinancialHighlight.FinancialStructure"),
                id: this.$t("FinancialHighlight.FinancialStructure"),
                num: res.data.financialStructurt,
              },
              {
                name: this.$t("FinancialHighlight.CreditOpinion"),
                id: this.$t("FinancialHighlight.CreditOpinion"),
                num: res.data.creditOpinion,
              },
              {
                name: this.$t("FinancialHighlight.RiskIndicator"),
                id: this.$t("FinancialHighlight.RiskIndicator"),
                num: res.data.riskIndicatorLower,
              },
              {
                name: this.$t("FinancialHighlight.Solvencyindex"),
                id: this.$t("FinancialHighlight.Solvencyindex"),
                num: res.data.solvencyindexSI,
              },
            ];
            this.$emit("UpdatamarkTotalList", this.manManagementSummary);
          } else {
            this.$emit("UpdatamarkTotalList", []);
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    getFinancialsList() {
      const id3a = this.$route.query.id3a;
      getFinancials({ id3a: id3a }).then((res) => {
        if (res.code == 200) {
          let data = res;
          this.isFinacialshow = true;
          let { highlight, years, unit, nodataYears } = data.data;
          this.yearslist1 = years;
          this.nodataYears1 = nodataYears;
          this.profitablitylist = highlight;
          this.untia = unit;
        } else {
          this.isFinacialshow = false;
          this.profitablitylist = [];
        }
      });
    },
    scrollToTop(anchor) {
      this.Related = true;
      if (this.parentTablelist.length == 0) {
        this.getrelateList();
      }

      const el = document.querySelector(anchor);
      el.scrollIntoView({ behavior: "smooth" });
    },
    createDialogcheck(value) {
      this.createDialog = value;
    },

    infiniteScroll() {
      this.routeLoad = false;
    },
    getrelateList() {
      (this.loginStatus1 = []),
        getrelatedCompanylist({
          id3a: this.$route.query.id3a,
          type: 1,
          page: this.page.pageNo,
          pageSize: this.page.pageSize,
          resourceType: 1,
        }).then((res) => {
          if (res.code == 200) {
            this.parentTablelist = res.data.rows;

            this.routeLoad = false;
            // this.parentTablelist = res.data.rows;

            this.parentTablelist.map((item) => {
              item.yearslist = this.yearslist;
              item.profitablitylist1 = [];
              item.loading2 = false;

              // item.loading1=fal
            });
          }
        });
    },
    async loginPop(index, id, nameEn) {
      this.indexclose = index;
      this.$set(this.loginStatus1, index, !this.loginStatus1[index]);
      if (this.loginStatus1[index]) {
        //   this.loading1=true
        this.parentTablelist[index].loading2 = true;
        const params = {
          id3a: id,
        };

        if (true) {
          getFinancials(params).then((res) => {
            if (!res.code) {
              this.parentTablelist[index].profitablitylist1 = [];
              this.parentTablelist[index].loading2 = false;
            }
            this.parentTablelist[index].loading2 = false;
            // let data = JSON.parse(crypto.decrypt(res));
            let data = res;

            let { highlight, years, unit, nodataYears } = data.data;

            this.parentTablelist[index].yearslist = years;
            this.parentTablelist[index].nodataYears1 = nodataYears;
            this.id3a = years;
            this.parentTablelist[index].profitablitylist1 = highlight;
            this.untia = unit;
          });
        }
      }
    },
    // insertMethod
    // srcviewscompanydetailsBackgroundSnapshotvueMethodStart
    // default
    default() {},
    // srcviewscompanydetailsBackgroundSnapshotvueMethodEnd
  },
};
</script>
<style scoped>
.uPdtqFl {
  padding-right: 2.857142857142857rem;
  padding-top: 2.142857142857143rem;
  padding-left: 2.857142857142857rem;
  padding-bottom: 2.142857142857143rem;
  box-shadow: 0rem 0.14285714285714285rem 1rem 0rem rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-top-left-radius: 0.2857142857142857rem;
  border-bottom-left-radius: 0.2857142857142857rem;
  border-top-right-radius: 0.2857142857142857rem;
  border-bottom-right-radius: 0.2857142857142857rem;
}

.importDetail-head {
  display: flex;
}

.flex_center_between_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.contclass {
  font-size: 1.285714285714286rem;
  color: #1290c9;
  font-style: normal;
  cursor: pointer;
}

.ViewMore {
  line-height: 32px;
  text-align: left;
  font-style: normal;
  font-size: 20px;
}
.ViewMore span {
  text-decoration-line: underline;
}

.uc1096 {
  height: 100%;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title-left {
  display: flex;
  font-size: 18px;
  font-family: "Arial Bold";
  font-weight: normal;
  color: #022955;
  padding-left: 1.4285714285714286rem;
  display: flex;
  align-items: center;
  /* padding-bottom: 11px;
  padding-top: 11px; */
  /* background-color: #f2f5f9; */
}

.title-left .relate-left {
  font-family: "Arial Bold";
}

.footer {
  /* margin-top: 1.4285714285714286rem; */
  /* padding: 0.9285714285714286rem 1.4285714285714286rem; */
  padding-left: 0rem;

  overflow: hidden;
  /* background: #ffffff;
    box-shadow: 0rem 0.14285714285714285rem 0.42857142857142855rem 0.07142857142857142rem rgba(10, 33, 57, 0.14); */
  /* border-radius: 1rem; */
}

.ecahrts-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.07142857142857142rem solid #cccccc;
}

.td {
  margin: 1.0714285714285714rem 0 0 1.7857142857142858rem;
}

.relate-left {
  height: 58px;
  font-size: 18px;
  color: #1a2332;
  /* line-height: 4rem; */
  text-align: left;
  display: flex;
  align-items: center;
  white-space: normal !important;
  word-break: keep-all;
  /* font-family: 'Arial Bold'; */
}

.relate-Financial {
  font-size: 18px;
  color: #1a2332;
  align-items: center;
  width: 15%;
}

.ecahrts-header-one .relate-Financial,
.ecahrts-header-one {
  font-size: 18px;
}

.computer_right_cont_box {
  margin-top: 20px;
}

.uUIRzUi {
  padding: 30px 40px;
}

.ecahrtstu {
  width: 100%;
}

.ecahrts-header-one {
  background-color: #f2f5f9;
  height: 3.57142857rem;
  /* line-height: 3.57142857rem; */
}

.Financial-icon-box {
  display: none;
  width: 500px;
  background: #ffffff;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  position: absolute;

  left: -430px;
  top: -20rem;
  z-index: 10;
  padding: 20px;
  color: #29445d;
  font-size: 18px;
}

.Financial-icon-part {
  position: relative;
  /* left: 5px; */
}

.Financial-icon-part:hover .Financial-icon-box {
  display: block;
}

.Financial-icon-boxtwo {
  display: none;
  left: -140px;
  top: -17.1428571rem;
  line-height: 28px;
}

.Financial-icon-parttwo:hover .Financial-icon-boxtwo {
  display: block;
}

.huanggantanhaoicon {
  font-size: 30px;
  margin-left: 8px;
  color: #ff7600;
}
.riliicon {
  font-size: 32px;
  margin-left: 40px;
  color: #1290c9;
}
.cuowuicon {
  font-size: 30px;
}

@media screen and (max-width: 1920px) {
  .uUIRzUi {
    padding: 22px 30px;
  }

  .huanggantanhaoicon {
    font-size: 22px;
    margin-left: 6px;
  }
  .riliicon {
    font-size: 24px;
    margin-left: 30px;
  }
  .cuowuicon {
    font-size: 22px;
  }
  .ViewMore {
    line-height: 24px;
    font-size: 16px;
  }
  .relate-left {
    height: 50px;
    font-size: 16px;
  }
  .relate-Financial {
    font-size: 16px;
  }
  .ecahrts-header-one .relate-Financial,
  .ecahrts-header-one {
    height: 44px;
    line-height: 44px;
    font-size: 16px;
  }
  .Financial-icon-box {
    font-size: 14px;
  }
}

@media (max-width: 1439px) {
  .uUIRzUi {
    padding: 20px 26px;
  }

  .huanggantanhaoicon {
    font-size: 20px;
    margin-left: 5px;
  }
  .riliicon {
    font-size: 22px;
    margin-left: 26px;
  }
  .cuowuicon {
    font-size: 20px;
  }
  .ViewMore {
    line-height: 22px;
    font-size: 14px;
  }
  .title-left {
    padding-top: 7px;
    padding-bottom: 7px;
  }
  .relate-left {
    height: 40px;
    font-size: 12px;
  }
  .ecahrts-header-one .relate-Financial,
  .ecahrts-header-one {
    font-size: 12px;
  }
  .Financial-icon-box {
    font-size: 12px;
  }
}
</style>
